
import { FoodItem, MealType, MealSlot } from '@/types/meal-plan';
import { ClientIntakeData } from '@/components/meal-planning/ClientIntakeForm';
import { ENHANCED_MEAL_ALTERNATIVES } from './meal-database';
import { scoreMeals } from './meal-scoring';

export const suggestMealSwap = async (
  mealSlot: MealSlot,
  clientPreferences?: Partial<ClientIntakeData>
): Promise<FoodItem[]> => {
  const { type: mealType } = mealSlot;

  // Filter meals based on the meal type
  let suitableMeals = ENHANCED_MEAL_ALTERNATIVES[mealType] || [];

  if (clientPreferences) {
    // Apply client preferences to filter meals
    if (clientPreferences.dietaryPreference === 'vegetarian') {
      suitableMeals = suitableMeals.filter(meal => meal.dietaryTags?.includes('vegetarian'));
    }
    if (clientPreferences.foodExclusions) {
      const excludedIngredients = clientPreferences.foodExclusions.toLowerCase().split(',');
      suitableMeals = suitableMeals.filter(meal =>
        !excludedIngredients.some(ingredient => meal.name.toLowerCase().includes(ingredient.trim()))
      );
    }
  }

  // Score each meal based on client preferences and nutritional needs
  const clientProfile = {
    dietaryPreference: clientPreferences?.dietaryPreference || 'vegetarian',
    healthGoals: [clientPreferences?.healthGoals || 'General wellness'],
    regionPreference: 'Indian',
    activityLevel: clientPreferences?.activityLevel || 'moderately_active',
    age: clientPreferences?.age || 30,
    restrictions: clientPreferences?.foodExclusions ? clientPreferences.foodExclusions.split(',') : []
  };

  const scoredMeals = scoreMeals(suitableMeals, clientProfile);

  // Sort meals by score in descending order
  scoredMeals.sort((a, b) => b.score - a.score);

  return scoredMeals.slice(0, 5); // Return top 5 meals
};
